export default "__VITE_ASSET__BZmiE1VH__"